import { RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.vendors.root,
    element: <Loadable component={() => import('./pages/VendorsPage')} />,
  },
  {
    path: paths.vendors.details,
    element: (
      <Loadable component={() => import('./pages/VendorsDetailsPage')} />
    ),
  },
];
